import { render } from "./CsatPage.vue?vue&type=template&id=3090125e&scoped=true"
import script from "./CsatPage.vue?vue&type=script&lang=js"
export * from "./CsatPage.vue?vue&type=script&lang=js"

import "./CsatPage.vue?vue&type=style&index=0&id=3090125e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3090125e"]])

export default __exports__